import JSONAPISerializer from "@ember-data/serializer/json-api";

type Payload = {
  data: {
    attributes: Record<string, string>;
    relationships: Record<string, string>;
  };
};

export default class extends JSONAPISerializer {
  attrs = {
    passwordChangedAt: { serialize: false }
  };

  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options) as Payload;

    if (!snapshot.record.isNew) {
      // The API does not accept these values if updating.
      delete json.data.attributes["role"];
      delete json.data.attributes["is-super-user"];
      delete json.data.relationships["health-centres"];
      delete json.data.attributes["refresh-tokens-enabled"];
      delete json.data.attributes["aph-code"];
      delete json.data.attributes["use-medics-v2"];
    }

    return json;
  }
}
